import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Cluster from "../../../domains/Cluster";
import GasoilQuality from "../../../domains/Recommendations/GasoilQuality";
import SplitFactor from "../../../domains/Recommendations/SplitFactor";

import { SLICE_NAME } from "./types";

interface ClusterInfoState {
  cluster: Cluster
  splitFactor: SplitFactor | null
  gasoilQuality: GasoilQuality | null
}

const initialState: ClusterInfoState = {
  cluster: {
    clusterPorts: [],
    clusterQuality: {
      name: "",
    },
    maxMatchClusterPort: undefined,
  },

  splitFactor: null,
  gasoilQuality: null,
};

export const clusterInfoSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setCluster: (state, action: PayloadAction<Cluster>) => {
      state.cluster = action.payload;
    },
    setSplitFactor: (state, action: PayloadAction<SplitFactor>) => {
      state.splitFactor = action.payload;
    },
    setGasoilQuality: (state, action: PayloadAction<GasoilQuality>) => {
      state.gasoilQuality = action.payload;
    },
    clearClusterInfo: state => {
      state.cluster = initialState.cluster;
      state.gasoilQuality = null;
      state.splitFactor = null;
    },
  },
});

export const {
  setCluster,
  setSplitFactor,
  setGasoilQuality,
  clearClusterInfo,
} = clusterInfoSlice.actions;

export default clusterInfoSlice.reducer;
